<snelstart-ui-details
        [config]="detailsConfig"
        [entityId]="id"
        [showTitleBorder]="isIdExcluded(id) || (!isIdExcluded(id) && !gezamenlijkeAangifte)"
        [title]="getTitle()"
>
    @if (!isIdExcluded(id) && gezamenlijkeAangifte) {
        <snelstart-ui-details-header>
            <snelstart-ui-tab>
                @if (selectedTab === 0) {
                    <snelstart-ui-tab-item (click)="onSelectTab(0)"
                                           [isActive]="selectedTab === 0"
                                           id="firstTab">
                        Aangever: {{ naamAangever }}
                    </snelstart-ui-tab-item>
                }
                @if (selectedTab === 1) {
                    <snelstart-ui-tab-item (click)="onSelectTab(0)"
                                           id="firstTab1">
                        Aangever: {{ naamAangever }}
                    </snelstart-ui-tab-item>
                }
                @if (selectedTab === 1) {
                        <snelstart-ui-tab-item (click)="onSelectTab(1)"
                                               [isActive]="selectedTab === 1"
                                               id="secondTab">
                            Partner: {{ naamPartner }}
                        </snelstart-ui-tab-item>
                }
                @if (selectedTab === 0) {
                    <snelstart-ui-tab-item (click)="onSelectTab(1)"
                                           id="secondTab1">
                        Partner: {{ naamPartner }}
                    </snelstart-ui-tab-item>
                }
            </snelstart-ui-tab>
        </snelstart-ui-details-header>
    }

    <snelstart-ui-details-content [ngClass]="{'partner-active': partnerBoolean}">
        @if (isLoading) {
            <div class="spinner-container">
                <snelstart-ui-spinner></snelstart-ui-spinner>
            </div>
        } @else {
            <!-- Persoonlijk-->
            @if (id === 'Aangever') {
                <snelstart-venture-fiscaal-feature-aangever></snelstart-venture-fiscaal-feature-aangever>
            }
            @if (id === 'Wijziging burgerlijke staat') {
                <snelstart-venture-fiscaal-feature-relatiegegevens></snelstart-venture-fiscaal-feature-relatiegegevens>
            }
            @if (id === 'Partner') {
                <snelstart-venture-fiscaal-feature-partner></snelstart-venture-fiscaal-feature-partner>
            }
            @if (id === 'Kinderen') {
                <snelstart-venture-fiscaal-feature-kind></snelstart-venture-fiscaal-feature-kind>
            }
            @if (id === 'Soort aangifte') {
                <snelstart-venture-fiscaal-feature-vertegenwoordiger></snelstart-venture-fiscaal-feature-vertegenwoordiger>
            }
            @if (id === 'VIA inlezen') {
                <snelstart-venture-fiscaal-feature-via></snelstart-venture-fiscaal-feature-via>
            }

            <!--Box 1 Winst uit onderneming-->

            @if (id === 'Onderneming') {
                <snelstart-venture-fiscaal-feature-algemeen
                        [partner]="partner"></snelstart-venture-fiscaal-feature-algemeen>
            }
            @if (id === 'Administratie inlezen') {
                <snelstart-venture-fiscaal-feature-administratie-koppelen-ib
                        [partner]="partner"></snelstart-venture-fiscaal-feature-administratie-koppelen-ib>
            }
            @if (id === 'Vragen vooraf') {
                <snelstart-venture-fiscaal-feature-vragen-vooraf-ond
                        [partner]="partner"></snelstart-venture-fiscaal-feature-vragen-vooraf-ond>
            }
            @if (id === 'Resultatenrekening') {
                <snelstart-venture-fiscaal-feature-winst-en-verlies
                        [partner]="partner"></snelstart-venture-fiscaal-feature-winst-en-verlies>
            }
            @if (id === 'Balans activa') {
                <snelstart-venture-fiscaal-feature-balans-activa
                        [partner]="partner"></snelstart-venture-fiscaal-feature-balans-activa>
            }
            @if (id === 'Balans passiva') {
                <snelstart-venture-fiscaal-feature-balans-passiva
                        [partner]="partner"></snelstart-venture-fiscaal-feature-balans-passiva>
            }
            @if (id === 'Samenwerkingsverband') {
                <snelstart-venture-fiscaal-feature-samenwerkingsverband
                        [partner]="partner"></snelstart-venture-fiscaal-feature-samenwerkingsverband>
            }
            @if (id === 'Priveonttrekkingen en -stortingen') {
                <snelstart-venture-fiscaal-feature-prive-ontrekkingen-en-stortingen
                        [partner]="partner"></snelstart-venture-fiscaal-feature-prive-ontrekkingen-en-stortingen>
            }
            @if (id === 'Vermogensvergelijking') {
                <snelstart-venture-fiscaal-feature-vermogensvergelijking
                        [partner]="partner"></snelstart-venture-fiscaal-feature-vermogensvergelijking>
            }
            @if (id === 'Investeringen') {
                <snelstart-venture-fiscaal-feature-investeringen
                        [partner]="partner"></snelstart-venture-fiscaal-feature-investeringen>
            }
            @if (id === 'Winstcorrecties') {
                <snelstart-venture-fiscaal-feature-winstcorrecties
                        [partner]="partner"></snelstart-venture-fiscaal-feature-winstcorrecties>
            }
            @if (id === 'Ondernemersaftrek') {
                <snelstart-venture-fiscaal-feature-ondernemer
                        [partner]="partner"></snelstart-venture-fiscaal-feature-ondernemer>
            }
            @if (id === 'Samenvatting winst') {
                <snelstart-venture-fiscaal-feature-box1-winst-uit-onderneming
                        [partner]="partner"></snelstart-venture-fiscaal-feature-box1-winst-uit-onderneming>
            }

            <!--Box 1 loon-->

            @if (id === 'Inkomsten uit loondienst') {
                <snelstart-venture-fiscaal-feature-loon-tegenwoordig
                        [partner]="partner"></snelstart-venture-fiscaal-feature-loon-tegenwoordig>
            }
            @if (id === 'Pensioen en andere uitkeringen') {
                <snelstart-venture-fiscaal-feature-loon-vroeger
                        [partner]="partner"></snelstart-venture-fiscaal-feature-loon-vroeger>
            }
            @if (id === 'Buitenlands loon') {
                <snelstart-venture-fiscaal-feature-loon-buitenland
                        [partner]="partner"></snelstart-venture-fiscaal-feature-loon-buitenland>
            }
            @if (id === 'Vrijgesteld loon') {
                <snelstart-venture-fiscaal-feature-loon-internationale-organisatie
                        [partner]="partner"></snelstart-venture-fiscaal-feature-loon-internationale-organisatie>
            }
            @if (id === 'Meer banen of uitkeringen tegelijk') {
                <snelstart-venture-fiscaal-feature-meer-banen-tegelijk
                        [partner]="partner"></snelstart-venture-fiscaal-feature-meer-banen-tegelijk>
            }
            @if (id === 'Reiskosten openbaar vervoer') {
                <snelstart-venture-fiscaal-feature-reisaftrek-ov
                        [partner]="partner"></snelstart-venture-fiscaal-feature-reisaftrek-ov>
            }
            @if (id === 'Samenvatting loon') {
                <snelstart-venture-fiscaal-feature-box1-belastbaar-loon
                        [partner]="partner"></snelstart-venture-fiscaal-feature-box1-belastbaar-loon>
            }

            <!--Box 1 row-->

            @if (id === 'Resultaat uit overige werkzaamheden') {
                <snelstart-venture-fiscaal-feature-resultaat-uit-overige-werkzaamheden
                        [partner]="partner"></snelstart-venture-fiscaal-feature-resultaat-uit-overige-werkzaamheden>
            }
            @if (id === 'Terbeschikkingstellingsregeling') {
                <snelstart-venture-fiscaal-feature-tbs-regeling
                        [partner]="partner"></snelstart-venture-fiscaal-feature-tbs-regeling>
            }

            <!--Box 1 belastbare periodieke uitkeringen en verstrekkingen-->

            @if (id === 'Alimentatie') {
                <snelstart-venture-fiscaal-feature-alimentatie
                        [partner]="partner"></snelstart-venture-fiscaal-feature-alimentatie>
            }
            @if (id === 'Periodieke uitkeringen') {
                <snelstart-venture-fiscaal-feature-periodieke-uitkeringen
                        [partner]="partner"></snelstart-venture-fiscaal-feature-periodieke-uitkeringen>
            }
            @if (id === 'Samenvatting overige inkomsten') {
                <snelstart-venture-fiscaal-feature-box1-resultaat-overige-werkzaamheden
                        [partner]="partner"></snelstart-venture-fiscaal-feature-box1-resultaat-overige-werkzaamheden>
            }

            <!--Box 1 belastbare inkomsten op basis van overgangsrecht-->

            @if (id === 'Inkomsten overgangsrecht') {
                <snelstart-venture-fiscaal-feature-box1-belastbare-inkomsten-op-basis-van-overgangsrecht></snelstart-venture-fiscaal-feature-box1-belastbare-inkomsten-op-basis-van-overgangsrecht>
            }

            <!--Box 1 belastbare inkomsten uit eigen woning-->

            @if (id === 'Woningen') {
                <snelstart-venture-fiscaal-feature-eigenwoningen></snelstart-venture-fiscaal-feature-eigenwoningen>
            }
            @if (id === 'Eigenwoningschulden') {
                <snelstart-venture-fiscaal-feature-eigenwoning-schulden></snelstart-venture-fiscaal-feature-eigenwoning-schulden>
            }
            @if (id === 'Financieringskosten') {
                <snelstart-venture-fiscaal-feature-financieringskosten></snelstart-venture-fiscaal-feature-financieringskosten>
            }
            @if (id === 'Restschulden') {
                <snelstart-venture-fiscaal-feature-eigenwoning-restschulden></snelstart-venture-fiscaal-feature-eigenwoning-restschulden>
            }
            @if (id === 'Huurinkomsten') {
                <snelstart-venture-fiscaal-feature-huurinkomsten></snelstart-venture-fiscaal-feature-huurinkomsten>
            }
            @if (id === 'Overig eigen woning') {
                <snelstart-venture-fiscaal-feature-overig-eigen-woning></snelstart-venture-fiscaal-feature-overig-eigen-woning>
            }
            @if (id === 'Samenvatting eigen woning') {
                <snelstart-venture-fiscaal-feature-box1-belastbare-inkomsten-uit-eigenwoning></snelstart-venture-fiscaal-feature-box1-belastbare-inkomsten-uit-eigenwoning>
            }

            <!--Box 1 uitgaven voor inkomensvoorzieningen-->

            @if (id === 'Premies lijfrente') {
                <snelstart-venture-fiscaal-feature-lijfrente-premies
                        [partner]="partner"></snelstart-venture-fiscaal-feature-lijfrente-premies>
            }
            @if (id === 'Jaar- en reserveringsruimte') {
                <snelstart-venture-fiscaal-feature-jaarruimtegegevens
                        [partner]="partner"></snelstart-venture-fiscaal-feature-jaarruimtegegevens>
            }
            @if (id === 'Overige premies inkomensvoorzieningen') {
                <snelstart-venture-fiscaal-feature-overige-premies
                        [partner]="partner"></snelstart-venture-fiscaal-feature-overige-premies>
            }
            @if (id === 'Samenvatting premies inkomensvoorzieningen') {
                <snelstart-venture-fiscaal-feature-box1-uitgaven-voor-inkomensvoorzieningen
                        [partner]="partner"></snelstart-venture-fiscaal-feature-box1-uitgaven-voor-inkomensvoorzieningen>
            }

            <!--Box 1 negatieve premies  -->

            @if (id === 'Teruggave premies inkomensvoorzieningen') {
                <snelstart-venture-fiscaal-feature-box1-negatieve-uitgaven-voor-inkomensvoorzieningen
                        [partner]="partner"></snelstart-venture-fiscaal-feature-box1-negatieve-uitgaven-voor-inkomensvoorzieningen>
            }

            <!--Box2-->

            @if (id === 'Aanmerkelijk belang (box 2)') {
                <snelstart-venture-fiscaal-feature-box2-inkomen-uit-aanmerkelijk-belang
                        [partner]="partner"></snelstart-venture-fiscaal-feature-box2-inkomen-uit-aanmerkelijk-belang>
            }
            @if (id === 'Samenvatting aanmerkelijk belang') {
                <snelstart-venture-fiscaal-feature-box2-inkomen-uit-ab></snelstart-venture-fiscaal-feature-box2-inkomen-uit-ab>
            }

            <!--Box 3-->

            @if (id === 'Werkelijk rendement') {
                <snelstart-venture-fiscaal-feature-box3-owr></snelstart-venture-fiscaal-feature-box3-owr>
            }
            @if (id === 'Bankrekeningen') {
                <snelstart-venture-fiscaal-feature-box3-bankrekeningen></snelstart-venture-fiscaal-feature-box3-bankrekeningen>
            }
            @if (id === 'Beleggingen') {
                <snelstart-venture-fiscaal-feature-box3-beleggingsrekeningen></snelstart-venture-fiscaal-feature-box3-beleggingsrekeningen>
            }
            @if (id === 'Overige onroerende zaken') {
                <snelstart-venture-fiscaal-feature-box3-overige-onroerende-zaken></snelstart-venture-fiscaal-feature-box3-overige-onroerende-zaken>
            }
            @if (id === 'Overige bezittingen') {
                <snelstart-venture-fiscaal-feature-box3-overige-bezittingen></snelstart-venture-fiscaal-feature-box3-overige-bezittingen>
            }
            @if (id === 'Schulden') {
                <snelstart-venture-fiscaal-feature-box3-leningen></snelstart-venture-fiscaal-feature-box3-leningen>
            }
            @if (id === 'Samenvatting box 3') {
                <snelstart-venture-fiscaal-feature-box3></snelstart-venture-fiscaal-feature-box3>
            }


            <!--        PGA-->
            <snelstart-venture-fiscaal-feature-pga-specifieke-zorgkosten
                    *ngIf="id === 'Specifieke zorgkosten'">
            </snelstart-venture-fiscaal-feature-pga-specifieke-zorgkosten>
            <snelstart-venture-fiscaal-feature-pga-aftrekbare-giften
                    *ngIf="id === 'Giften'">
            </snelstart-venture-fiscaal-feature-pga-aftrekbare-giften>
            <snelstart-venture-fiscaal-feature-pga-scholingsuitgaven
                    *ngIf="id === 'Scholingsuitgaven'">
            </snelstart-venture-fiscaal-feature-pga-scholingsuitgaven>
            <snelstart-venture-fiscaal-feature-pga-onderhoudsverplichtingen
                    *ngIf="id === 'Onderhoudsverplichtingen'"></snelstart-venture-fiscaal-feature-pga-onderhoudsverplichtingen>
            <snelstart-venture-fiscaal-feature-pga-weekenduitgaven-gehandicapte-kinderen
                    *ngIf="id === 'Weekenduitgaven gehandicapte kinderen'"></snelstart-venture-fiscaal-feature-pga-weekenduitgaven-gehandicapte-kinderen>
            <snelstart-venture-fiscaal-feature-pga-restant-pga-voorgaande-jaren
                    *ngIf="id === 'Restant persoonsgebonden aftrek voorgaande jaren'"></snelstart-venture-fiscaal-feature-pga-restant-pga-voorgaande-jaren>
            <snelstart-venture-fiscaal-feature-box1-negatieve-persoonsgebonden-aftrek
                    *ngIf="id === 'Negatieve persoonsgebonden aftrek'"
                    [partner]="partner"></snelstart-venture-fiscaal-feature-box1-negatieve-persoonsgebonden-aftrek>
            <snelstart-venture-fiscaal-feature-pga-samenvatting
                    *ngIf="id === 'Samenvatting persoonsgebonden aftrek'"></snelstart-venture-fiscaal-feature-pga-samenvatting>

            <!--        Heffingskortingen-->
            <snelstart-venture-fiscaal-feature-heffingskortingen
                    *ngIf="id === 'xxxxxx'"></snelstart-venture-fiscaal-feature-heffingskortingen>
            <!--    Verdeling-->
            <snelstart-venture-fiscaal-feature-verdeling
                    *ngIf="id === 'Verdeling'"></snelstart-venture-fiscaal-feature-verdeling>

            <!--    Voorheffingen-->
            <snelstart-venture-fiscaal-feature-voorlopige-aanslagen *ngIf="id === 'Voorlopige aanslagen'"
                                                                    [partner]="partner"></snelstart-venture-fiscaal-feature-voorlopige-aanslagen>
            <snelstart-venture-fiscaal-feature-dividendbelasting
                    *ngIf="id === 'Nederlandse dividendbelasting'"></snelstart-venture-fiscaal-feature-dividendbelasting>
            <snelstart-venture-fiscaal-feature-buitenlandse-bronheffing
                    *ngIf="id === 'Buitenlandse bronbelasting'"></snelstart-venture-fiscaal-feature-buitenlandse-bronheffing>

            <snelstart-venture-fiscaal-feature-loon-onderdeel-winst *ngIf="id === 'Loon als onderdeel van winst'"
                                                                    [partner]="partner"></snelstart-venture-fiscaal-feature-loon-onderdeel-winst>

            <!--    Aanvullende vragen-->
            <snelstart-venture-fiscaal-feature-verrekenbare-verliezen *ngIf="id === 'Nog verrekenbaar'"
                                                                      [partner]="partner"></snelstart-venture-fiscaal-feature-verrekenbare-verliezen>

            <!--    vertegenwoordiger-->
            <snelstart-venture-fiscaal-feature-vertegenwoordiger
                    *ngIf="id === 'xxxxxx'"></snelstart-venture-fiscaal-feature-vertegenwoordiger>


            <!--    Overzicht & Berekeningen-->
            <snelstart-venture-fiscaal-feature-overzicht-inkomen-box1 *ngIf="id === 'Overzicht inkomen box 1'"
                                                                      [partner]="partner"></snelstart-venture-fiscaal-feature-overzicht-inkomen-box1>
            <snelstart-venture-fiscaal-feature-overzicht-inkomen-box2
                    *ngIf="id === 'Overzicht inkomen box 2'"></snelstart-venture-fiscaal-feature-overzicht-inkomen-box2>
            <snelstart-venture-fiscaal-feature-overzicht-inkomen-box3
                    *ngIf="id === 'Overzicht inkomen box 3'"></snelstart-venture-fiscaal-feature-overzicht-inkomen-box3>
            <snelstart-venture-fiscaal-feature-inkomstenbelasting *ngIf="id === 'Berekening inkomstenbelasting'"
                                                                  [partner]="partner"></snelstart-venture-fiscaal-feature-inkomstenbelasting>
            <snelstart-venture-fiscaal-feature-zorgverzekeringswet *ngIf="id === 'Berekening zorgverzekeringswet'"
                                                                   [partner]="partner"></snelstart-venture-fiscaal-feature-zorgverzekeringswet>

            <snelstart-venture-fiscaal-feature-rapport *ngIf="id === 'Rapport'"
                                                       [partner]="partner"></snelstart-venture-fiscaal-feature-rapport>
            <snelstart-venture-fiscaal-feature-aanslagen *ngIf="id === 'Aanslagen'"
                                                         [partner]="partner"></snelstart-venture-fiscaal-feature-aanslagen>

            @if (id === 'Premieplicht') {
                <snelstart-venture-fiscaal-feature-premieplicht
                        [partner]="partner"></snelstart-venture-fiscaal-feature-premieplicht>
            }
            @if (id === 'Wereldinkomen') {
                <snelstart-venture-fiscaal-feature-opgaaf-wereldinkomen
                        [partner]="partner"></snelstart-venture-fiscaal-feature-opgaaf-wereldinkomen>
            }
            @if (id === 'Conserverend inkomen') {
                <snelstart-venture-fiscaal-feature-conserverend-inkomen></snelstart-venture-fiscaal-feature-conserverend-inkomen>
            }


            <!--        Conserverend inkomen-->

                    <!--         APV Lijst-->
            <snelstart-venture-fiscaal-feature-apv-lijst
                    *ngIf="id === 'APV'"></snelstart-venture-fiscaal-feature-apv-lijst>
        }
    </snelstart-ui-details-content>

    <snelstart-ui-details-buttons>
        @if (showButtonOpslaan(id)) {
            <snelstart-ui-button [config]="config(id)"
                                 [disabled]="isSaving"
                                 class="me-2"
                                 type="primary">
                Opslaan
            </snelstart-ui-button>
        }
        @if (showButtonOpslaan(id)) {
            <snelstart-ui-button (click)="this.showDialogInfo()"
                                 type="secondary">
                Toelichting
            </snelstart-ui-button>
        }
    </snelstart-ui-details-buttons>

    <snelstart-ui-dialog-definition [(visible)]="dialogInfoVisible" id="toelIB"
                                    size="lg"
                                    title="Toelichting bij '{{id}}'">
        <snelstart-ui-dialog-body>
            <snelstart-venture-fiscaal-feature-tekst-persoonlijk-aangever
                    *ngIf="this.id ==='Aangever'"></snelstart-venture-fiscaal-feature-tekst-persoonlijk-aangever>
            <snelstart-venture-fiscaal-feature-tekst-persoonlijk-wijzigingBurgerlijkeStaat
                    *ngIf="this.id ==='Wijziging burgerlijke staat'"></snelstart-venture-fiscaal-feature-tekst-persoonlijk-wijzigingBurgerlijkeStaat>
            <snelstart-venture-fiscaal-feature-tekst-persoonlijk-partner
                    *ngIf="this.id ==='Partner'"></snelstart-venture-fiscaal-feature-tekst-persoonlijk-partner>
            <snelstart-venture-fiscaal-feature-tekst-persoonlijk-kinderen
                    *ngIf="this.id ==='Kinderen'"></snelstart-venture-fiscaal-feature-tekst-persoonlijk-kinderen>

            <snelstart-venture-fiscaal-feature-tekst-wuo-onderneming
                    *ngIf="this.id ==='Onderneming'"></snelstart-venture-fiscaal-feature-tekst-wuo-onderneming>
            <snelstart-venture-fiscaal-feature-tekst-wuo-adminKoppelen
                    *ngIf="this.id ==='Administratie inlezen'"></snelstart-venture-fiscaal-feature-tekst-wuo-adminKoppelen>
            <snelstart-venture-fiscaal-feature-tekst-wuo-vragenVooraf
                    *ngIf="this.id ==='Vragen vooraf'"></snelstart-venture-fiscaal-feature-tekst-wuo-vragenVooraf>
            <snelstart-venture-fiscaal-feature-tekst-wuo-resultatenrekening
                    *ngIf="this.id ==='Resultatenrekening'"></snelstart-venture-fiscaal-feature-tekst-wuo-resultatenrekening>
            <snelstart-venture-fiscaal-feature-tekst-wuo-balansActiva
                    *ngIf="this.id ==='Balans activa'"></snelstart-venture-fiscaal-feature-tekst-wuo-balansActiva>
            <snelstart-venture-fiscaal-feature-tekst-wuo-balansPassiva
                    *ngIf="this.id ==='Balans passiva'"></snelstart-venture-fiscaal-feature-tekst-wuo-balansPassiva>

            <snelstart-venture-fiscaal-feature-tekst-wuo-prive
                    *ngIf="this.id ==='Priveonttrekkingen en -stortingen'"></snelstart-venture-fiscaal-feature-tekst-wuo-prive>
            <snelstart-venture-fiscaal-feature-tekst-wuo-vermogensVergelijking
                    *ngIf="this.id ==='Vermogensvergelijking'"></snelstart-venture-fiscaal-feature-tekst-wuo-vermogensVergelijking>
            <snelstart-venture-fiscaal-feature-tekst-wuo-investeringen
                    *ngIf="this.id ==='Investeringen'"></snelstart-venture-fiscaal-feature-tekst-wuo-investeringen>
            <snelstart-venture-fiscaal-feature-tekst-wuo-winstcorrecties
                    *ngIf="this.id ==='Winstcorrecties'"></snelstart-venture-fiscaal-feature-tekst-wuo-winstcorrecties>
            <snelstart-venture-fiscaal-feature-tekst-oa-ondernemersaftrek
                    *ngIf="this.id ==='Ondernemersaftrek'"></snelstart-venture-fiscaal-feature-tekst-oa-ondernemersaftrek>

            <snelstart-venture-fiscaal-feature-tekst-loon-loondienst
                    *ngIf="this.id ==='Inkomsten uit loondienst'"></snelstart-venture-fiscaal-feature-tekst-loon-loondienst>
            <snelstart-venture-fiscaal-feature-tekst-loon-reiskostenOv
                    *ngIf="this.id ==='Reiskosten openbaar vervoer'"></snelstart-venture-fiscaal-feature-tekst-loon-reiskostenOv>
            <snelstart-venture-fiscaal-feature-tekst-loon-pensioen
                    *ngIf="this.id ==='Pensioen en andere uitkeringen'"></snelstart-venture-fiscaal-feature-tekst-loon-pensioen>
            <snelstart-venture-fiscaal-feature-tekst-loon-buitenland
                    *ngIf="this.id ==='Buitenlands loon'"></snelstart-venture-fiscaal-feature-tekst-loon-buitenland>
            <snelstart-venture-fiscaal-feature-tekst-loon-vrijgesteld
                    *ngIf="this.id ==='Vrijgesteld loon'"></snelstart-venture-fiscaal-feature-tekst-loon-vrijgesteld>
            <snelstart-venture-fiscaal-feature-tekst-loon-meerBanen
                    *ngIf="this.id ==='Meer banen of uitkeringen tegelijk'"></snelstart-venture-fiscaal-feature-tekst-loon-meerBanen>

            <snelstart-venture-fiscaal-feature-tekst-overigInkomen-row
                    *ngIf="this.id ==='Resultaat uit overige werkzaamheden'"></snelstart-venture-fiscaal-feature-tekst-overigInkomen-row>
            <snelstart-venture-fiscaal-feature-tekst-overigInkomen-tbs
                    *ngIf="this.id ==='Terbeschikkingstellingsregeling'"></snelstart-venture-fiscaal-feature-tekst-overigInkomen-tbs>
            <snelstart-venture-fiscaal-feature-tekst-overigInkomen-alimentatie
                    *ngIf="this.id ==='Alimentatie'"></snelstart-venture-fiscaal-feature-tekst-overigInkomen-alimentatie>
            <snelstart-venture-fiscaal-feature-tekst-overigInkomen-pu
                    *ngIf="this.id ==='Periodieke uitkeringen'"></snelstart-venture-fiscaal-feature-tekst-overigInkomen-pu>

            <snelstart-venture-fiscaal-feature-tekst-woning-woningen
                    *ngIf="this.id ==='Woningen'"></snelstart-venture-fiscaal-feature-tekst-woning-woningen>
            <snelstart-venture-fiscaal-feature-tekst-woning-ews
                    *ngIf="this.id ==='Eigenwoningschulden'"></snelstart-venture-fiscaal-feature-tekst-woning-ews>
            <snelstart-venture-fiscaal-feature-tekst-woning-financieringskosten
                    *ngIf="this.id ==='Financieringskosten'"></snelstart-venture-fiscaal-feature-tekst-woning-financieringskosten>
            <snelstart-venture-fiscaal-feature-tekst-woning-restschulden
                    *ngIf="this.id ==='Restschulden'"></snelstart-venture-fiscaal-feature-tekst-woning-restschulden>
            <snelstart-venture-fiscaal-feature-tekst-woning-huurinkomsten
                    *ngIf="this.id ==='Huurinkomsten'"></snelstart-venture-fiscaal-feature-tekst-woning-huurinkomsten>
            <snelstart-venture-fiscaal-feature-tekst-woning-overig
                    *ngIf="this.id ==='Overig eigen woning'"></snelstart-venture-fiscaal-feature-tekst-woning-overig>

            <snelstart-venture-fiscaal-feature-tekst-premies-lijfrente
                    *ngIf="this.id ==='Premies lijfrente'"></snelstart-venture-fiscaal-feature-tekst-premies-lijfrente>
            <snelstart-venture-fiscaal-feature-tekst-premies-jaarruimte
                    *ngIf="this.id ==='Jaar- en reserveringsruimte'"></snelstart-venture-fiscaal-feature-tekst-premies-jaarruimte>
            <snelstart-venture-fiscaal-feature-tekst-premies-overig
                    *ngIf="this.id ==='Overige premies inkomensvoorzieningen'"></snelstart-venture-fiscaal-feature-tekst-premies-overig>
            <snelstart-venture-fiscaal-feature-tekst-premies-teruggave
                    *ngIf="this.id ==='Teruggave premies inkomensvoorzieningen'"></snelstart-venture-fiscaal-feature-tekst-premies-teruggave>

            <snelstart-venture-fiscaal-feature-tekst-ab-inkomen
                    *ngIf="this.id ==='Aanmerkelijk belang (box 2)'"></snelstart-venture-fiscaal-feature-tekst-ab-inkomen>

            <snelstart-venture-fiscaal-feature-tekst-box3-werkelijkRendement
                    *ngIf="this.id ==='Werkelijk rendement'"></snelstart-venture-fiscaal-feature-tekst-box3-werkelijkRendement>
            <snelstart-venture-fiscaal-feature-tekst-box3-bank
                    *ngIf="this.id ==='Bankrekeningen'"></snelstart-venture-fiscaal-feature-tekst-box3-bank>
            <snelstart-venture-fiscaal-feature-tekst-box3-beleggingen
                    *ngIf="this.id ==='Beleggingen'"></snelstart-venture-fiscaal-feature-tekst-box3-beleggingen>
            <snelstart-venture-fiscaal-feature-tekst-box3-onrZaken
                    *ngIf="this.id ==='Overige onroerende zaken'"></snelstart-venture-fiscaal-feature-tekst-box3-onrZaken>
            <snelstart-venture-fiscaal-feature-tekst-box3-overig
                    *ngIf="this.id ==='Overige bezittingen'"></snelstart-venture-fiscaal-feature-tekst-box3-overig>
            <snelstart-venture-fiscaal-feature-tekst-box3-schulden
                    *ngIf="this.id ==='Schulden'"></snelstart-venture-fiscaal-feature-tekst-box3-schulden>

            <snelstart-venture-fiscaal-feature-tekst-pga-zorg
                    *ngIf="this.id ==='Specifieke zorgkosten'"></snelstart-venture-fiscaal-feature-tekst-pga-zorg>
            <snelstart-venture-fiscaal-feature-tekst-pga-giften
                    *ngIf="this.id ==='Giften'"></snelstart-venture-fiscaal-feature-tekst-pga-giften>
            <snelstart-venture-fiscaal-feature-tekst-pga-scholing
                    *ngIf="this.id ==='Scholingsuitgaven'"></snelstart-venture-fiscaal-feature-tekst-pga-scholing>
            <snelstart-venture-fiscaal-feature-tekst-pga-onderhoud
                    *ngIf="this.id ==='Onderhoudsverplichtingen'"></snelstart-venture-fiscaal-feature-tekst-pga-onderhoud>
            <snelstart-venture-fiscaal-feature-tekst-pga-weekend
                    *ngIf="this.id ==='Weekenduitgaven gehandicapte kinderen'"></snelstart-venture-fiscaal-feature-tekst-pga-weekend>
            <snelstart-venture-fiscaal-feature-tekst-pga-restant
                    *ngIf="this.id ==='Restant persoonsgebonden aftrek voorgaande jaren'"></snelstart-venture-fiscaal-feature-tekst-pga-restant>
            <snelstart-venture-fiscaal-feature-tekst-pga-negatief
                    *ngIf="this.id ==='Negatieve persoonsgebonden aftrek'"></snelstart-venture-fiscaal-feature-tekst-pga-negatief>

            <snelstart-venture-fiscaal-feature-tekst-premievrijstelling
                    *ngIf="this.id ==='Premieplicht'"></snelstart-venture-fiscaal-feature-tekst-premievrijstelling>
            <snelstart-venture-fiscaal-feature-tekst-wereldinkomen
                    *ngIf="this.id ==='Wereldinkomen'"></snelstart-venture-fiscaal-feature-tekst-wereldinkomen>

            <snelstart-venture-fiscaal-feature-tekst-voorheffingen-va
                    *ngIf="this.id ==='Voorlopige aanslagen'"></snelstart-venture-fiscaal-feature-tekst-voorheffingen-va>
            <snelstart-venture-fiscaal-feature-tekst-voorheffingen-divBel
                    *ngIf="this.id ==='Nederlandse dividendbelasting'"></snelstart-venture-fiscaal-feature-tekst-voorheffingen-divBel>
            <snelstart-venture-fiscaal-feature-tekst-voorheffingen-buitenlBronbel
                    *ngIf="this.id ==='Buitenlandse bronbelasting'"></snelstart-venture-fiscaal-feature-tekst-voorheffingen-buitenlBronbel>
            <snelstart-venture-fiscaal-feature-tekst-voorheffingen-loonWinst
                    *ngIf="this.id ==='Loon als onderdeel van winst'"></snelstart-venture-fiscaal-feature-tekst-voorheffingen-loonWinst>

            <snelstart-venture-fiscaal-feature-tekst-verrVerlies
                    *ngIf="this.id ==='Nog verrekenbaar'"></snelstart-venture-fiscaal-feature-tekst-verrVerlies>

            <snelstart-venture-fiscaal-feature-tekst-verdeling
                    *ngIf="this.id ==='Verdeling'"></snelstart-venture-fiscaal-feature-tekst-verdeling>

            <snelstart-venture-fiscaal-feature-tekst-berekening-belasting
                    *ngIf="this.id ==='Berekening inkomstenbelasting'"></snelstart-venture-fiscaal-feature-tekst-berekening-belasting>

            <snelstart-venture-fiscaal-feature-tekst-berekening-premieZvw
                    *ngIf="this.id ==='Berekening zorgverzekeringswet'"></snelstart-venture-fiscaal-feature-tekst-berekening-premieZvw>

            <!-- algemene informatie van Belastingdienst-->
            <div class="accordion" id="accordionExample">

                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingMeer">
                        <button aria-controls="collapseMeer" aria-expanded="false"
                                class="accordion-button collapsed"
                                data-bs-target="#collapseMeer" data-bs-toggle="collapse" type="button">
                            Meer fiscale informatie
                        </button>
                    </h2>
                    <div aria-labelledby="headingMeer" class="accordion-collapse collapse"
                         data-bs-parent="#accordionExample"
                         id="collapseMeer">
                        <div class="accordion-body">
                            De Belastingdienst heeft elk jaar bij de aangifte inkomstenbelasting online uitgebreide
                            informatie over de belastingregels beschikbaar.

                            <div class="space20"></div>

                            <snelstart-ui-button iconRight="arrow-up-right-from-square" size="small"
                                                 type="secondary">
                                <div *ngIf="this.year.toString() === '2024'">
                                    <a href=" https://www.belastingdienst.nl/bibliotheek/handboeken/html/boeken/FISIN2024/index.html"
                                       target="_blank">
                                        Fiscale informatie inkomstenbelasting 2024
                                    </a>
                                </div>
                                <div *ngIf="this.year.toString() === '2025'">
                                    <a href=" https://www.belastingdienst.nl/wps/wcm/connect/fisin/fisin2025/index"
                                       target="_blank">
                                        Fiscale informatie inkomstenbelasting 2025
                                    </a>
                                </div>
                                <div *ngIf="this.year.toString() === '2026'">
                                    <a href=" https://www.belastingdienst.nl/wps/wcm/connect/fisin/fisin2026/index"
                                       target="_blank">
                                        Fiscale informatie inkomstenbelasting 2026
                                    </a>
                                </div>
                            </snelstart-ui-button>
                        </div>
                    </div>
                </div>
            </div>

            <!--nog niet in aangifteprogramma-->
            <div class="accordion" id="accordionIB">

                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingIBr">
                        <button aria-controls="collapseIB" aria-expanded="false" class="accordion-button collapsed"
                                data-bs-target="#collapseIB" data-bs-toggle="collapse" type="button">
                            (Niet) Beschikbare onderdelen in aangifte inkomstenbelasting
                        </button>
                    </h2>
                    <div aria-labelledby="headingIB" class="accordion-collapse collapse"
                         data-bs-parent="#accordionExample"
                         id="collapseIB">
                        <div class="accordion-body">
                            SnelStart Fiscaal groeit stapsgewijs in functionaliteiten. Eind 2025 is het dé oplossing
                            voor
                            alle soorten belastingaangiften, inclusief uitstel en beheer van machtigingsregister. De
                            uitbreidingen
                            volgen de komende maanden.
                            <div class="space20"></div>
                            <b>Wat zit er nog niet in de aangifte inkomstenbelasting?</b><br/>
                            De module voor de aangifte inkomstenbelasting voorziet momenteel nog niet in de volgende
                            onderdelen:<br/>
                            <ul>
                                <li>Afzonderlijk aangifte invullen bij fiscaal partners</li>
                                <li>Winst uit onderneming voor agrarische ondernemingen</li>
                                <li>Compensatieregelingen Nederlandse grensarbeiders</li>
                                <li>M-biljetten</li>
                                <li>Aangifte met een A.P.V. (Afgezonderd Particulier Vermogen)</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </snelstart-ui-dialog-body>

        <snelstart-ui-dialog-buttons class="d-flex mt-2">
            <snelstart-ui-button btn-x icon="check" id="sluiten" type="primary">Afsluiten
            </snelstart-ui-button>
        </snelstart-ui-dialog-buttons>
    </snelstart-ui-dialog-definition>
</snelstart-ui-details>
